module.exports = __webpack_public_path__ + "static/media/picto-sharing-blue-full.12b72f7d.svg";